// extracted by mini-css-extract-plugin
export default {"section":"ServiceDetailLayout_section__u3dnr","title":"ServiceDetailLayout_title__jP7pa"};